<template>
  <ShopInfo />
</template>

<script>
import ShopInfo from '@/components/shop/Shop.vue';

export default {
  name: 'Shop',
  components: {
    ShopInfo
  }
};
</script>

<style lang="scss"></style>
